// extracted by mini-css-extract-plugin
module.exports = {"topSpace":"59","navHeight":"52"};